import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloOpposizionePrecetto extends FascicoloFull {
    sezione: string;
    motivoOpposizione: string;
    numRuoloDecretoRif: string;
    posizioneFascicoloRif: string;
    dataInizioFascicoloRif: number;
    valoreFascicoloRif: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
